import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import Select from '@/components/forms/Select';
import Textarea from '@/components/forms/Textarea';
import { z } from 'zod';

const apiLogsFormSchema = z.object({
  code: z.string().min(1, { message: 'Code is required' }),
  message: z.string().min(2, {
    message: 'Message must be at least 2 characters.',
  }),
  engMessage: z.string().min(2, {
    message: 'Message must be at least 2 characters.',
  }),
  statusCode: z.string().min(2, {
    message: 'Message must be at least 2 characters.',
  }),
  description: z.string().min(1, { message: 'Description is required' }),
  categoryType: z.union([z.literal('apple'), z.literal('orange')]),
});

export const ApiLogsForm = () => {
  const form = useForm({ schema: apiLogsFormSchema, mode: 'all' });

  const FruitMap: Record<z.infer<typeof apiLogsFormSchema>['categoryType'], string> = {
    apple: 'Apple',
    orange: 'Orange',
  };

  const fruitOptions = Object.entries(FruitMap).map(([value, label]) => ({
    value,
    label,
  }));

  return (
    <Form
      className="overflow-y-auto"
      form={form}
      onSubmit={() => {
        return new Promise((res) => {
          setTimeout(res, 5000);
        });
      }}
    >
      <div className="w-full flex flex-col gap-4.5">
        <Input placeholder="A" label="logsManagement.page.apilogs.form.code" {...form.register('code')} />
        <Input
          placeholder="Enter Message"
          label="logsManagement.page.apilogs.form.message"
          {...form.register('message')}
        />
        <Input
          placeholder="Enter English Message"
          label="logsManagement.page.apilogs.form.engmessage"
          {...form.register('engMessage')}
        />
        <Input
          placeholder="Enter HTTP Status Code"
          label="logsManagement.page.apilogs.form.statusCode"
          {...form.register('statusCode')}
        />
        <Textarea
          placeholder="Write something.."
          label="logsManagement.page.apilogs.form.description"
          {...form.register('description')}
        />
        <Select
          label="logsManagement.page.apilogs.form.categorytype"
          {...form.register('categoryType')}
          options={fruitOptions}
          placeholder="Select"
        />
      </div>
    </Form>
  );
};
